/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface AuthenticateRequest {
    institutionId: string;
    institutionalResearcherId: string;
    redirectUrl: string;
    scope?: Array<string>;
    allowPublicUsageOfLimitedOrcidData?: boolean;
}

export interface ConnectRequest {
    institutionId: string;
    institutionalResearcherId: string;
    redirectUrl: string;
    code?: string;
    allowPublicUsageOfLimitedOrcidData?: boolean;
}

export interface DeleteTokenRequest {
    orcidId: string;
}

export interface RegisterWebhookRequest {
    orcidId: string;
}

export interface TokenRequest {
    orcidId: string;
    accessToken?: string;
}

export interface UnregisterWebhookRequest {
    orcidId: string;
}

/**
 * 
 */
export class AuthenticateApi extends runtime.BaseAPI {

    /**
     * Creates request options for authenticate without sending the request
     */
    async authenticateRequestOpts(requestParameters: AuthenticateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['institutionId'] == null) {
            throw new runtime.RequiredError(
                'institutionId',
                'Required parameter "institutionId" was null or undefined when calling authenticate().'
            );
        }

        if (requestParameters['institutionalResearcherId'] == null) {
            throw new runtime.RequiredError(
                'institutionalResearcherId',
                'Required parameter "institutionalResearcherId" was null or undefined when calling authenticate().'
            );
        }

        if (requestParameters['redirectUrl'] == null) {
            throw new runtime.RequiredError(
                'redirectUrl',
                'Required parameter "redirectUrl" was null or undefined when calling authenticate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['institutionId'] != null) {
            queryParameters['institution_id'] = requestParameters['institutionId'];
        }

        if (requestParameters['institutionalResearcherId'] != null) {
            queryParameters['institutional_researcher_id'] = requestParameters['institutionalResearcherId'];
        }

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        if (requestParameters['allowPublicUsageOfLimitedOrcidData'] != null) {
            queryParameters['allow_public_usage_of_limited_orcid_data'] = requestParameters['allowPublicUsageOfLimitedOrcidData'];
        }

        if (requestParameters['redirectUrl'] != null) {
            queryParameters['redirect_url'] = requestParameters['redirectUrl'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/auth/authenticate`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Authenticate to ORCID
     */
    async authenticateRaw(requestParameters: AuthenticateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authenticateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Authenticate to ORCID
     */
    async authenticate(requestParameters: AuthenticateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authenticateRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for connect without sending the request
     */
    async connectRequestOpts(requestParameters: ConnectRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['institutionId'] == null) {
            throw new runtime.RequiredError(
                'institutionId',
                'Required parameter "institutionId" was null or undefined when calling connect().'
            );
        }

        if (requestParameters['institutionalResearcherId'] == null) {
            throw new runtime.RequiredError(
                'institutionalResearcherId',
                'Required parameter "institutionalResearcherId" was null or undefined when calling connect().'
            );
        }

        if (requestParameters['redirectUrl'] == null) {
            throw new runtime.RequiredError(
                'redirectUrl',
                'Required parameter "redirectUrl" was null or undefined when calling connect().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['institutionId'] != null) {
            queryParameters['institution_id'] = requestParameters['institutionId'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['institutionalResearcherId'] != null) {
            queryParameters['institutional_researcher_id'] = requestParameters['institutionalResearcherId'];
        }

        if (requestParameters['allowPublicUsageOfLimitedOrcidData'] != null) {
            queryParameters['allow_public_usage_of_limited_orcid_data'] = requestParameters['allowPublicUsageOfLimitedOrcidData'];
        }

        if (requestParameters['redirectUrl'] != null) {
            queryParameters['redirect_url'] = requestParameters['redirectUrl'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/auth/connect`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * CONNECT ORCID record to MMS
     */
    async connectRaw(requestParameters: ConnectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.connectRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * CONNECT ORCID record to MMS
     */
    async connect(requestParameters: ConnectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.connectRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteToken without sending the request
     */
    async deleteTokenRequestOpts(requestParameters: DeleteTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orcidId'] == null) {
            throw new runtime.RequiredError(
                'orcidId',
                'Required parameter "orcidId" was null or undefined when calling deleteToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/auth/authenticate/{orcid_id}/token`;
        urlPath = urlPath.replace(`{${"orcid_id"}}`, encodeURIComponent(String(requestParameters['orcidId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Deletes/deactivate the ORCID API access token for the given ORCID iD.
     */
    async deleteTokenRaw(requestParameters: DeleteTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes/deactivate the ORCID API access token for the given ORCID iD.
     */
    async deleteToken(requestParameters: DeleteTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTokenRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for registerWebhook without sending the request
     */
    async registerWebhookRequestOpts(requestParameters: RegisterWebhookRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orcidId'] == null) {
            throw new runtime.RequiredError(
                'orcidId',
                'Required parameter "orcidId" was null or undefined when calling registerWebhook().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/auth/connect/{orcid_id}/webhook`;
        urlPath = urlPath.replace(`{${"orcid_id"}}`, encodeURIComponent(String(requestParameters['orcidId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Register a webhook for the given ORCID iD.
     */
    async registerWebhookRaw(requestParameters: RegisterWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.registerWebhookRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Register a webhook for the given ORCID iD.
     */
    async registerWebhook(requestParameters: RegisterWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.registerWebhookRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for token without sending the request
     */
    async tokenRequestOpts(requestParameters: TokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orcidId'] == null) {
            throw new runtime.RequiredError(
                'orcidId',
                'Required parameter "orcidId" was null or undefined when calling token().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accessToken'] != null) {
            queryParameters['access_token'] = requestParameters['accessToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/auth/authenticate/{orcid_id}/token`;
        urlPath = urlPath.replace(`{${"orcid_id"}}`, encodeURIComponent(String(requestParameters['orcidId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Is ORCID accesstoken currently valid.
     */
    async tokenRaw(requestParameters: TokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.tokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Is ORCID accesstoken currently valid.
     */
    async token(requestParameters: TokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.tokenRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for unregisterWebhook without sending the request
     */
    async unregisterWebhookRequestOpts(requestParameters: UnregisterWebhookRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orcidId'] == null) {
            throw new runtime.RequiredError(
                'orcidId',
                'Required parameter "orcidId" was null or undefined when calling unregisterWebhook().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/auth/connect/{orcid_id}/webhook`;
        urlPath = urlPath.replace(`{${"orcid_id"}}`, encodeURIComponent(String(requestParameters['orcidId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Unregister a webhook for the given ORCID iD.
     */
    async unregisterWebhookRaw(requestParameters: UnregisterWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.unregisterWebhookRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unregister a webhook for the given ORCID iD.
     */
    async unregisterWebhook(requestParameters: UnregisterWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unregisterWebhookRaw(requestParameters, initOverrides);
    }

}
